<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <div v-if="isViewPermissionSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!isViewPermissionSpinnerShow && viewPermissionItems.length == 0">{{$t('table.no_records')}}</div>
                    <div v-if="!isViewPermissionSpinnerShow && viewPermissionItems.length != 0">
                        <h6 class="mt-3 text-secondary fw-300">{{$t('user.header_sub_restriction', {'user': sTitle})}}</h6>
                        <b-table striped hover bordered :fields="fields" :items="viewPermissionItems" responsive>
                            <template #cell(index)="data">
                                {{ data.index + 1 }}
                            </template>
                            <template #cell(module)="data">
                                <ol class="breadcrumb breadcrumb-seperator-1 text-primary m-0">
                                    <li class="breadcrumb-item">
                                        <i class="fas mr-1 fs-md" :class="data.item.breadCrumbs.icon"></i>
                                        {{data.item.breadCrumbs.title}}
                                    </li>
                                    <li v-for="(itm, j) in data.item.breadCrumbs.subMenu" :key="j" class="breadcrumb-item">
                                        {{itm.text}}
                                    </li>
                                </ol>
                            </template>
                            <template #cell(action)="data">
                                <a v-if="sTitle != loginUsername"  class="link d-block text-primary" :title="$t('user.unblock_permission')" @click="unBlockPermission(data.item.permissionID, data.item.title)">
                                    <div class='icon-stack fs-xxl'>
                                        <i class="fal fa-do-not-enter icon-stack-2x opacity-100 color-primary-500"></i> <i class="fal fa-slash icon-stack-2x opacity-100 color-primary-500"></i>
                                    </div>
                                </a>
                                <a v-else  class="d-block text-secondary" :title="$t('message.error.access_denied_user_permission')" disabled>
                                    <div class='icon-stack fs-xxl'>
                                        <i class="fal fa-do-not-enter icon-stack-2x opacity-100 color-fusion-100"></i> <i class="fal fa-slash icon-stack-2x opacity-100 color-fusion-500"></i>
                                    </div>
                                </a>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
       <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import {handleSessionExpired, getBreadCrumbs} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "userPermissionList",
    components: {
        DeleteModal
    },
    data(){
        return{
            isViewPermissionSpinnerShow: false,
            viewPermissionItems: [],
            sTitle: "", userID: 0, permissionID: 0, loginUsername: "",
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "module", label: this.$i18n.t('table.header.restricted_module'), thClass: 'thead-themed align-middle'},
                { key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'}
            ]
        },
    },
    methods:{
        async closeModal(isError){
            if(!isError){
                this.$refs.deleteModal.toggleModal = false
                await this.getBlockPermission(this.userID, this.sTitle)
            }
            this.$parent.$parent.$parent.$parent.isModalShow = false;
        },
        async getBlockPermission(id, title){
            this.userID = id
            this.sTitle = title
            this.isViewPermissionSpinnerShow = true
            var result = await this.getPermission(id)
            for(var i=0; i<result.length; i++){
                result[i]["breadCrumbs"] = getBreadCrumbs(this, result[i].title)
            }
            this.isViewPermissionSpinnerShow = false;
            this.viewPermissionItems = result
            this.$emit('setPermissionType', result)
        },
        async getPermission(id){
            let $vm = this
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: `/users/${id}/permission`,
                baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                console.log(response.data.permissions)
                result = response.data.permissions
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            return result
        },
        performDeleteAction(){
            let $vm = this
            const url = $vm.$api.USER + "/" + $vm.userID + $vm.$api.USER_PERMISSION + "/" + $vm.permissionID + $vm.$api.DELETE
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.deleteToggleModal = false;
                    var message = $vm.$i18n.t('user.permission') + $vm.$i18n.t('message.success.unblock')
                    $vm.$parent.$parent.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        unBlockPermission(pID, title){
            this.permissionID = pID
            var navObj = getBreadCrumbs(this, title)
            var nav = navObj.title + " > " 
            for(var i=0; i<navObj.subMenu.length; i++){
                if(i == navObj.subMenu.length - 1){
                    nav += navObj.subMenu[i].text + "'"
                }else{
                    nav += navObj.subMenu[i].text + " > "
                }
            }
            var modalTitle = this.$i18n.t('user.unblock_permission')
            var message = this.$i18n.t('message.confirmation.unblock_permission', {'user': this.sTitle, 'item': nav}) 
            this.$refs.deleteModal.showModal(modalTitle, message)
        }
    },
    mounted(){
        let $vm = this;
        $vm.loginUsername = $vm.$store.state.userName
    },

}
</script>
<style scoped>
.show{
    display: block;
}
</style>